import { render, staticRenderFns } from "./ULTIMEINSERZIONI.vue?vue&type=template&id=1a8b2ba8"
import script from "./ULTIMEINSERZIONI.vue?vue&type=script&lang=ts"
export * from "./ULTIMEINSERZIONI.vue?vue&type=script&lang=ts"
import style0 from "./ULTIMEINSERZIONI.vue?vue&type=style&index=0&id=1a8b2ba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeIvgTheSkeleton: require('/usr/src/nuxt-app/components/home/ivg/TheSkeleton.vue').default})
